import { type PropsWithChildren } from 'react';

export const NewsBlockList = ({ children }: PropsWithChildren) => <ul>{children}</ul>;
